module.exports = "/_next/static/images/got-15-minutes-to-burn-67b611a6c25dcf3ff53692e5b0cea4da.png";